import React from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';

interface TabItemProps {
  icon?: React.ReactNode;
  label: string;
  count?: string | number;
}

const TabItem: React.FC<TabItemProps> = ({ icon, label, count }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {icon}
      <Typography variant="body2" fontWeight="bold" color="text.primary">
        {label}
      </Typography>
      {!!count && (
        <Typography variant="body2" color="text.secondary">
          ({count})
        </Typography>
      )}
    </Box>
  );
};

interface HorizontalTabsProps {
  items?: Array<{ label: string; value: string | number; icon?: React.ReactNode; count?: number }>;
  selectedTab: string | number;
  onChange: (_newValue: string | number) => void;
  size?: string;
  shape?: string;
}

const HorizontalTabs: React.FC<HorizontalTabsProps> = ({
  items,
  selectedTab,
  onChange,
  size = 'normal',
  shape = 'default'
}) => {

  const handleChange = (_newValue: string | number) => {
    onChange(_newValue);
  };

  if (!items?.length) {
    return null;
  }

  return (
    <Box
      sx={{
        bgcolor: '#f7f9fb',
        borderRadius: shape === 'rounded' ? '10px' : '50px',
        px: 1,
        py: size === 'small' ? 0.25 : 0.5,
        boxShadow: '0px 2px 6px rgba(0,0,0,0.1)',
        width: '100%',
        mx: 'auto',
      }}
    >
      <Tabs
        value={selectedTab}
        onChange={(e, value) => handleChange(value)}
        sx={{
          minHeight: size === 'small' ? '40px' : '48px',
          '& .MuiTabs-flexContainer': {
            gap: 1,
          },
        }}
        slotProps={{
          indicator: { style: { display: 'none' } },
        }}
      >
        {items.map((item, index) => (
          <Tab
            key={`horizontal-tab-${index}`}
            disableRipple
            label={<TabItem icon={item?.icon} label={item.label} count={item.count} />}
            sx={{
              textTransform: 'none',
              borderRadius: shape === 'rounded' ? '10px' : '50px',
              py: size === 'small' ? '10px' : '12px',
              px: 3,
              minHeight: size === 'small' ? '37px' : '40px',
              flex: 1,
              maxWidth: 'initial',
              '&.Mui-selected': {
                bgcolor: '#fff',
                boxShadow: '0px 2px 6px rgba(0,0,0,0.15)',
              },
            }}
            value={item.value}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default HorizontalTabs;
